// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__Uwqz6","title":"Images45_title__1OPNt","images":"Images45_images__1enzJ"};